import * as React from 'react';

/**
 * Type-inferring hook for tracking the previous instance of any value (useful
 * for comparing with prevProps/prevState).
 */
export const usePrevious = <T>(value: T): T | undefined => {
  const ref = React.useRef<T>();
  React.useEffect(() => {
    ref.current = value;
  });
  return ref.current;
};
